import React from 'react';

const TableTemplate = ({ properties = {}, tableTitle }) => {
  const entries = Object.entries(properties);

  const fontFamily = `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif`;

const renderValue = (value, key) => {
  
  if ((key === 'Pohjavesialueet' || key === 'Tulvariski') && Array.isArray(value) && value.length === 0) {
    const text = key === 'Pohjavesialueet'
      ? 'Ei pohjavesialueita 500 metrin säteellä'
      : 'Ei tulvariskialueita 500 metrin säteellä';
    return <span>{text}</span>;
  }

  if (Array.isArray(value) && value.length > 0 && typeof value[0] === 'object') {
    
    const keys = Object.keys(value[0]);
    return (
      <table className="table table-sm table-bordered mb-0">
        <thead>
          <tr>
            {keys.map((k) => (
              <th key={k}>{k.charAt(0).toUpperCase() + k.slice(1)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {value.map((item, idx) => (
            <tr key={idx}>
              {keys.map((k) => (
                <td key={k}>{item[k] ?? '-'}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  } else if (Array.isArray(value)) {
    // Simple array of strings/numbers
    return value.join(', ');
  }

  return value ?? '-';
};

  return (
    <div className="mb-1" style={{ fontFamily }}>
      <style>
        {`
          .responsive-table {
            font-size: 0.9rem;
          }
          @media (max-width: 576px) {
            .responsive-table {
              font-size: 0.75rem;
            }
            .responsive-table th {
              white-space: normal;
            }
          }
        `}
      </style>

      {tableTitle && (
        <h5 className="mb-3 text-primary fw-semibold" style={{ fontWeight: 600 }}>
          {tableTitle}
        </h5>
      )}

      {entries.length === 0 ? (
        <p className="text-muted fst-italic">Ei tietoja saatavilla</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered align-middle responsive-table" style={{ fontFamily }}>
            <tbody>
              {entries.map(([key, { value } = {}]) => {
                const label = key
                  .replace(/([A-Z])/g, ' $1')
                  .replace(/^./, (str) => str.toUpperCase());
                return (
                  <tr key={key}>
                    <th
                      scope="row"
                      style={{
                        backgroundColor: '#f8f9fa',
                        fontWeight: 600,
                        whiteSpace: 'nowrap',
                        width: '30%',
                      }}
                      title={label}
                    >
                      {label}
                    </th>
                      <td style={{ color: '#212529' }} title={typeof value === 'string' ? value : ''}>
                        {renderValue(value, key)}
                      </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TableTemplate;
